import React from "react";
import { FiArrowUpRight } from "react-icons/fi";
import { useLanguage } from "../LanguageContext";
import useScrollReveal from "../../utils/useScrollReveal";

import "../../assets/css/projects.css";
import "../../assets/css/font.css";

const SELECTED = [
  {
    name: "Events Calendar App",
    href: "https://events-orcin.vercel.app/",
    description: "Calendar application built fullstack: Next.js, TypeScript, React, Tailwind, Express and MongoDB.",
  },
  {
    name: "Scheduler",
    href: "https://scheduler-eosin.vercel.app/",
    description: "Scheduling app with a Next.js/TypeScript frontend and a dedicated Express + TypeScript API.",
  },
  {
    name: "Scheduler API",
    href: "https://github.com/viniciuspx/scheduler-api",
    description: "Backend service for the Scheduler project, built with Node.js, TypeScript and ExpressJS.",
  },
  {
    name: "json2csv",
    href: "https://github.com/viniciuspx/json2csv",
    description: "JSON to CSV converter with a Java 17 + Spring Boot backend and a ReactJS frontend.",
  },
];

const MORE = [
  { name: "iResume", href: "https://iresume-web.vercel.app/" },
  { name: "Shop Home Page", href: "https://monogram-pi.vercel.app/" },
  { name: "ezCEP", href: "https://viniciuspx.github.io/ezcep/" },
  { name: "Ghost Help Center", href: "https://viniciuspx.github.io/ghost-help-center/" },
  { name: "CSS Ladder", href: "https://viniciuspx.github.io/css-ladder/" },
];

function Projects() {
  const { t } = useLanguage();
  const [ref, visible] = useScrollReveal();

  return (
    <section
      id="projects"
      ref={ref}
      className={`section projects reveal ${visible ? "is-visible" : ""}`}
    >
      <div className="container">
        <span className="eyebrow">{t.projects.eyebrow}</span>
        <h2 className="section-heading">{t.projects.title}</h2>
        <p className="section-intro projects-intro">{t.projects.intro}</p>

        <div className="project-grid">
          {SELECTED.map((project) => (
            <a
              className="project-card"
              key={project.name}
              href={project.href}
              target="_blank"
              rel="noreferrer"
            >
              <div className="project-card-header">
                <span className="project-card-name">{project.name}</span>
                <FiArrowUpRight className="project-card-icon" aria-hidden="true" />
              </div>
              <p className="project-card-desc">{project.description}</p>
            </a>
          ))}
        </div>

        <div className="project-more">
          <h3 className="mono">{t.projects.moreTitle}</h3>
          <ul className="project-more-list">
            {MORE.map((project) => (
              <li key={project.name}>
                <a href={project.href} target="_blank" rel="noreferrer">
                  {project.name}
                </a>
              </li>
            ))}
          </ul>
          <a
            className="project-more-link"
            href="https://github.com/viniciuspx"
            target="_blank"
            rel="noreferrer"
          >
            {t.projects.moreLinkText}
            <FiArrowUpRight aria-hidden="true" />
          </a>
        </div>
      </div>
    </section>
  );
}

export default Projects;
